import type { AvatarResult } from '../../../types/avatarFlow';
import { Grid3x3 } from './Grid3x3';
import { Grid4x4 } from './Grid4x4';
import { ZodiacCarousel12 } from './ZodiacCarousel12';

export interface ResultGridProps {
  result: AvatarResult;
  onSelectFrame: (index: number) => void;
  onCrossSell?: () => void;
  onRebrew?: () => void;
  onBack?: () => void;
  testId?: string;
}

export function ResultGrid({ result, onSelectFrame, onCrossSell, onRebrew, onBack, testId }: ResultGridProps): JSX.Element {
  switch (result.variant) {
    case 'grid-3x3':
      return (
        <Grid3x3
          frames={result.frames}
          onSelectFrame={onSelectFrame}
          onCrossSell={onCrossSell}
          onRebrew={onRebrew}
          onBack={onBack}
          testId={testId}
        />
      );
    case 'grid-4x4':
      return <Grid4x4 frames={result.frames} onSelectFrame={onSelectFrame} testId={testId} />;
    case 'zodiac-carousel-12':
      return <ZodiacCarousel12 result={result} onSelectFrame={onSelectFrame} testId={testId} />;
    default:
      return <Grid3x3 frames={result.frames} onSelectFrame={onSelectFrame} testId={testId} />;
  }
}
